import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Login} from '../model/login';
import {LoginService} from './login.service';
import {TokenStorageService} from './token.storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

    login: Login| undefined;

    constructor(private router: Router, private loginService: LoginService, private tokenStorageService: TokenStorageService) {
        this.loginService.get().subscribe(login => {
            this.login = login;
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.login) {
            this.login = this.tokenStorageService.getLoginInfo();
        }
        if (this.login) {
            return true
        } else {
            this.router.navigate(['']).then();
            return false;
        }
    }
}
